import React, { useContext } from 'react';
import { LowerLevelList } from './LowerLevelList';
import { promoRecommendation } from 'contexts/PromoRecommendationContext';
import { calculateFontSize } from 'utils/helperMethods';
import _ from 'lodash';
import { notification } from 'antd';
import { scaledHeight } from 'components/molecules/PromoRecommendation/AddEditSpends';
import { trackEventMixpanel } from 'utils/mixpanel';
import {
    PROMO_RECOMMENDATION_ADD_EVENT_EDIT_PRODUCT_OPEN_INPUT,
    PROMO_RECOMMENDATION_ADD_EVENT_EDIT_PRODUCT_SHIPPER_INPUT,
    PROMO_RECOMMENDATION_ADD_EVENT_PRODUCT_SELECTED_REMOVED,
    PROMO_RECOMMENDATION_EDIT_EVENT_EDIT_PRODUCT_OPEN_INPUT,
    PROMO_RECOMMENDATION_EDIT_EVENT_EDIT_PRODUCT_SHIPPER_INPUT,
} from 'utils/mixpanelEventNames';

export const limitMessage = 'Error: Please provide values <=100 and >= 0';
export const limitAltMessage = 'Error: Please provide values <=52 and >= 0';

function LowerLevelSection() {
    const { addLeverData, setAddLeverData, editMode } = useContext(promoRecommendation);
    function editOpenShipper(nameOfLowerLevel: any, inputType: any, e: any) {
        //if value greater than 100 or less than 0 then show error notification
        if (parseInt(e.target.value) > 100 || parseInt(e.target.value) < 0 || e.target.value == '-') {
            notification.open({
                message: limitMessage,
                className: 'custom-class',
                style: {
                    width: 350,
                    height: 70,
                },
            });
            return;
        }
        setAddLeverData((data: any) => {
            let cloneData = _.cloneDeep(data);
            let selectedData = cloneData['SelectedLowerLevel'][nameOfLowerLevel];
            selectedData[inputType] = parseInt(e.target.value);
            if (inputType == 'openStock') {
                selectedData['shipperStock'] = 100 - e.target.value;
            } else {
                selectedData['openStock'] = 100 - e.target.value;
            }
            cloneData['SelectedLowerLevel'][nameOfLowerLevel] = selectedData;
            return cloneData;
        });
    }

    function deleteSelection(item: any) {
        setAddLeverData((oldData: any) => {
            let data = _.cloneDeep(oldData);
            delete data['SelectedLowerLevel'][item];
            return data;
        });
    }

    return (
        <div className="border-collapse border border-borderLinePurpuleAlt mt-2 rounded-t font-medium h-full">
            <div className="flex w-full justify-between bg-bgBackground border-solid border-0 border-b border-borderLinePurpuleAlt  text-purpleFont">
                <div className="flex w-full">
                    <div className="flex py-2 pl-2">
                        <span>Product Selection</span>
                    </div>
                </div>
                <div className="flex w-full">
                    <div className="flex py-2 pl-2">
                        <span>Edit Product</span>
                    </div>
                </div>
            </div>
            <div className="flex w-full h-full justify-between">
                <div className="flex flex-col w-full p-2">
                    {/* PPG Selection */}
                    <LowerLevelList />
                    <div
                        className="flex flex-col w-full mt-2 gap-2 overflow-auto"
                        style={{ height: scaledHeight - 45 }}
                    >
                        {Object.keys(addLeverData['SelectedLowerLevel']).map((item: any) => {
                            return (
                                <span
                                    className={` ${
                                        'colorChange' in addLeverData['SelectedLowerLevel'][item]
                                            ? 'bg-bgBackground text-purpleFont'
                                            : 'bg-purpleFont text-white'
                                    } w-full  py-1 px-1 rounded font-xxs flex justify-between items-center`}
                                    key={item}
                                >
                                    <span>{addLeverData['SelectedLowerLevel'][item].promptName}</span>
                                    <span
                                        className="font-xxs px-2 cursor-pointer"
                                        onClick={() => {
                                            deleteSelection(item);
                                            trackEventMixpanel(
                                                PROMO_RECOMMENDATION_ADD_EVENT_PRODUCT_SELECTED_REMOVED,
                                                {
                                                    removedProductName: item,
                                                },
                                            );
                                        }}
                                    >
                                        <span>X</span>
                                    </span>
                                </span>
                            );
                        })}
                    </div>
                </div>
                <div
                    className="flex w-full flex-col overflow-auto font-medium border-collapse border-solid border-0 border-l border-borderLinePurpuleAlt"
                    style={{ height: scaledHeight }}
                >
                    {Object.keys(addLeverData['SelectedLowerLevel']).length ? (
                        Object.keys(addLeverData['SelectedLowerLevel']).map((item: any) => {
                            return (
                                <div
                                    className="p-2 font-xxs w-full border-solid border-0 border-b border-borderLinePurpuleAlt !text-fontGray"
                                    key={item}
                                >
                                    <span className="font-xs">
                                        {addLeverData['SelectedLowerLevel'][item].promptName}
                                    </span>
                                    <div className="flex flex-col gap-2 mt-2 ">
                                        <div className="flex justify-between w-full items-center">
                                            <span>Open Stock (%)</span>
                                            <span className="border border-purpleFont rounded">
                                                <input
                                                    onWheel={(e) => e.currentTarget?.blur()}
                                                    min={'0'}
                                                    className="m-0.5 focus:outline-none"
                                                    value={addLeverData['SelectedLowerLevel'][item].openStock}
                                                    placeholder="Enter open stock"
                                                    onChange={(e) => {
                                                        editOpenShipper(item, 'openStock', e);
                                                        trackEventMixpanel(
                                                            editMode
                                                                ? PROMO_RECOMMENDATION_EDIT_EVENT_EDIT_PRODUCT_OPEN_INPUT
                                                                : PROMO_RECOMMENDATION_ADD_EVENT_EDIT_PRODUCT_OPEN_INPUT,
                                                            {
                                                                inputValue: e.target.value,
                                                            },
                                                        );
                                                    }}
                                                    type="number"
                                                />
                                            </span>
                                        </div>
                                        <div className="flex justify-between w-full items-center">
                                            <span>Shipper Stock (%)</span>
                                            <span className="border border-purpleFont rounded">
                                                <input
                                                    onWheel={(e) => e.currentTarget?.blur()}
                                                    min={'0'}
                                                    className="m-0.5 focus:outline-none"
                                                    value={addLeverData['SelectedLowerLevel'][item].shipperStock}
                                                    placeholder="Enter shipper stock"
                                                    onChange={(e) => {
                                                        editOpenShipper(item, 'shipperStock', e);
                                                        trackEventMixpanel(
                                                            editMode
                                                                ? PROMO_RECOMMENDATION_EDIT_EVENT_EDIT_PRODUCT_SHIPPER_INPUT
                                                                : PROMO_RECOMMENDATION_ADD_EVENT_EDIT_PRODUCT_SHIPPER_INPUT,
                                                            {
                                                                inputValue: e.target.value,
                                                            },
                                                        );
                                                    }}
                                                    type="number"
                                                />
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            );
                        })
                    ) : (
                        <div className="w-full h-full flex justify-center items-center font-xxs !text-fontGray font-medium">
                            <span>Add PPGs from the dropdown</span>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default LowerLevelSection;
